import React from 'react';
import Hero from './Hero';
import Categories from './Categories';
import Featured from './Featured';
import EventTypeCarousel from './EventTypeCarousel';
import Destinations from './Destinations';
import HowItWorks from './HowItWorks';
import Values from './Values';

export default function Home() {
  return (
    <main className="bg-surface">
      <Hero />
      <Categories />
      <Featured />
      <EventTypeCarousel
        type="Event"
        titleKey="home.voyagesTitle"
        subtitleKey="home.voyagesSubtitle"
        viewAllKey="home.voyagesViewAll"
        viewAllHref="/events?type=Event"
        surface="default"
      />
      <Destinations />
      <EventTypeCarousel
        type="Activitie"
        titleKey="home.activitiesTitle"
        subtitleKey="home.activitiesSubtitle"
        viewAllKey="home.activitiesViewAll"
        viewAllHref="/events?type=Activitie"
        surface="default"
      />
      <EventTypeCarousel
        type="Sejour"
        titleKey="home.staysTitle"
        subtitleKey="home.staysSubtitle"
        viewAllKey="home.staysViewAll"
        viewAllHref="/events?type=Sejour"
        surface="muted"
      />
      <HowItWorks />
      <Values />
    </main>
  );
}
